import { Component, OnInit, Input, signal, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { BankCard } from '@interface/bank-card.interface';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PipesModule } from '@pipes/pipes.module';
import { CookieUtil } from '@utils/cookies';
import { HttpResponse } from '@angular/common/http';
import { UtilsMethods_Services } from '@utils/utils';
import { SimulateInvestmentV2Service } from '@apiShared/simulate-investment/v2/simulate-investment-v2.service';
// import { ValidateTurboCdtService } from '@apiShared/process-status/validate-turbo-cdt/validate-turbo-cdt.service';
import { NgbActiveModal, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
// import { AlertConfirmComponent } from '../../../../resources-alerts/alert-confirm/alert-confirm.component';
import { ModalSharedLoginComponent } from '../../../../../modals-shared/login/login.component';
import { environment } from '@enviroment/environment';
import { ScreenService } from '@utils/screen';
import { take, Subject, takeUntil, Subscription } from 'rxjs';
import { ModalsSharedModule } from 'src/app/modals-shared/modals-shared.module';
import { GtmService } from '@apiShared/analytics/gtm';
import { SessionStorageUtil } from '@utils/sessionStorage';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { BonusService } from '@services/bonus/bonus.service';
import { BonusResult } from '@services/bonus/interfaces/bonus.interface';
import { BonusProcessHelper } from '@class/helper/bonus-process-helper';
import { Globals } from '@config/global';
import { AttendedByCoachComponent } from '../attended-by-coach.component';

interface BankOption {
  rate: number;
  term: number;
  roi: number;
  decile: number;
}

@Component({
  selector: 'app-modal-investment-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PipesModule,
    FormsModule,
    NgbTooltipModule,
    ModalsSharedModule,
    DirectivesModule,
    AttendedByCoachComponent,
  ],
  template: `
    <!-- Modal Content -->
    <div
      class="screenBloqe align-items-center"
      style="justify-items: center"
      [ngClass]="{
        'd-none': !LoadFormSend,
        'd-grid': LoadFormSend,
      }"
    >
      <img [src]="env.S3_STATIC_FILES + '/images/web/gif-load-refresh.svg'" width="70px" alt="" />
    </div>
    <div class="modal-content border-0 position-relative" [style.opacity]="LoadFormSend ? '0.5' : '1'">
      <!-- Header -->
      <div
        class="modal-header border-0 p-0 d-flex justify-content-between align-items-start"
        [style.opacity]="LoadFormSend ? '0.5' : '1'"
      >
        <div
          class="text-size-nl py-2"
          [ngClass]="{
            'px-3 opening-time-badge': resolution === 1,
            'px-2': resolution === 2,
            'turbo-badge': turboCDT && selectedPayment === 'pse',
            'bg-blue-20': (!turboCDT || selectedPayment === 'other') && selectedOptionIndex !== bestRateOptionIndex,
            'bg-blue-100 text-white':
              (!turboCDT || selectedPayment === 'other') && selectedOptionIndex === bestRateOptionIndex,
          }"
        >
          @if (turboCDT && selectedPayment === 'pse') {
            <i class="bi bi-lightning"></i>
            <span class="font-bold">Turbo</span>
            apertura en 8 min
          } @else {
            @if (selectedOptionIndex === bestRateOptionIndex) {
              <b>La mejor opción</b> para este plazo
            } @else {
              Apertura <span class="font-semibold">20 min</span> aprox
            }
          }
        </div>
        <button
          type="button"
          class="bg-black-50 text-white text-size-md m-3 rounded-circle border-0 d-flex align-items-center justify-content-center p-0 position-absolute end-0 closeModalCheckParameters"
          style="width: 30px; height: 30px;"
          (click)="this.CloseModalCheckParameters()"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body p-0 py-2 mt-2">
        <div
          [ngClass]="{
            'px-3 mx-2': resolution === 1,
            'mx-3': resolution === 2,
          }"
        >
          <div class="text-center mb-2">
            <h4 class="title-6">Confirma los datos de tu inversión con</h4>
            <img
              [src]="
                env.S3_STATIC_FILES + '/images/web/logos/bancos/' + utils.removeAccents(dataBank.bank_label) + '.png'
              "
              [alt]="'Apertura con ' + dataBank.bank_label"
              class="object-fit-contain img-aperture p-2"
            />
          </div>

          <!-- Investment Details Cards -->
          <div
            class="row mx-0"
            [ngClass]="{
              'mb-3': resolution === 1,
              'mb-2': resolution === 2,
            }"
          >
            <!-- Investment Amount Card -->
            <div class="col-md-6 mb-2 ps-md-0 pe-md-2 ps-0 pe-0">
              <div
                class="rounded-3 px-3 border-blue-100 d-flex justify-content-between align-items-center position-relative"
                [ngClass]="{
                  'py-2': resolution === 1,
                  'py-1': resolution === 2,
                }"
              >
                <!-- <div class="mx-2 text-size-lg">
                  <i class="bi bi-cash-coin me-2 text-blue-100 icon-investment-card position-absolute"></i>
                </div> -->
                <div class="my-1">
                  <span class="font-semibold d-block text-size-sm">Tu inversión por</span>
                  @if (activateEditAmount()) {
                    <div [formGroup]="form" class="d-flex align-items-center">
                      <span class="text-size-lg me-2">$</span>
                      <input
                        #amountInput
                        type="text"
                        class="form-control p-1 text-size-md me-1"
                        formControlName="amount"
                        (keyup)="thousandSeparator($event)"
                      />
                    </div>
                  } @else {
                    <span class="text-size-md">{{ amount() | currency: 'CO' }}</span>
                  }
                </div>
                <button class="border-0 bg-white text-size-sm text-blue-100 ps-2 pe-0 mt-md-3" (click)="onEditClick()">
                  <i
                    class="bi me-1 text-size-lg"
                    [ngClass]="{
                      'bi-check-circle': activateEditAmount(),
                      'bi-pencil-square': !activateEditAmount(),
                    }"
                  ></i>
                  <!-- {{ activateEditAmount() ? 'Actualizar' : 'Editar' }} -->
                </button>
              </div>
            </div>

            <!-- Investment Term Card -->
            <div class="col-md-6 mb-2 pe-md-0 ps-md-2 pe-0 ps-0" [class.opacity-50]="loading">
              <div
                class="rounded-3 px-3 border-blue-100 d-flex justify-content-between align-items-center"
                [ngClass]="{
                  'py-2': resolution === 1,
                  'py-1': resolution === 2,
                }"
              >
                <!-- <div class="mx-2 text-size-lg">
                  <i class="bi bi-calendar2-week text-blue-100 icon-investment-card position-absolute"></i>
                </div> -->
                <div class="my-1">
                  <span class="font-semibold d-block text-size-sm"> Plazo de la inversión </span>
                  <span
                    [ngClass]="{
                      'text-size-lg': activateEditAmount(),
                      'text-size-md': !activateEditAmount(),
                    }"
                    >{{ investmentTerm | months }}</span
                  >
                  <div class="dropdown" *ngIf="validOptions.length > 1">
                    <ul class="dropdown-menu" [class.show]="isTermDropdownOpen">
                      <li *ngFor="let option of validOptions; let i = index" class="position-relative">
                        <a
                          class="dropdown-item d-flex align-items-center justify-content-between"
                          [ngClass]="{
                            active: i === selectedOptionIndex && !isTermDisabled(option.term),
                            'disabled-term': isTermDisabled(option.term),
                          }"
                          (click)="
                            !isTermDisabled(option.term) && onTermSelectionChange(getOriginalOptionIndex(option))
                          "
                        >
                          <span
                            [ngClass]="{ 'text-muted': isTermDisabled(option.term) }"
                            (click)="toggleTermDropdown()"
                            class="cursor-pointer"
                          >
                            {{ option.term | months }} - {{ option.rate }}%
                          </span>

                          <!-- Ícono de ayuda para términos con restricciones (tanto bloqueo como advertencia) -->
                          <i
                            *ngIf="bonusService.isTermIncompatibleWithBonus(option.term)"
                            class="bi bi-question-circle-fill text-secondary ms-2 cursor-pointer"
                            [TooltipMCDT]="getDisabledTermTooltip(option.term)"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button class="border-0 bg-white p-2" type="button" (click)="toggleTermDropdown()" [disabled]="loading">
                  <i class="bi bi-chevron-{{ isTermDropdownOpen ? 'up' : 'down' }}"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Title -->

        <!-- CDT Profitability Section -->
        <div
          class="mt-2 py-md-3"
          [class.opacity-50]="loading"
          [ngClass]="{
            'bg-blue-10 px-3 mx-0': resolution === 1,
            'bg-blue-20 rounded-4 pb-3 mx-3': resolution === 2,
          }"
        >
          <div
            class="text-center"
            [ngClass]="{
              'mx-5 mb-1': resolution === 1,
              'mx-0 mb-3 bg-blue-60 rounded-top-4 p-2': resolution === 2,
            }"
          >
            <span
              class="fw-bold text-size-nl"
              [ngClass]="{
                'text-blue-180': resolution === 1,
                'text-white': resolution === 2,
              }"
              >Rentabilidad CDT</span
            >
          </div>

          <div
            class="row text-blue-180 align-items-center"
            [ngClass]="{
              'mx-3': resolution === 1,
              'mx-0 px-3': resolution === 2,
            }"
          >
            <!-- Interest Generated -->
            <div
              class="col-md-6 px-0"
              [ngClass]="{
                'border-end border-blue-60': resolution === 1,
                'pb-2': resolution === 2,
              }"
            >
              <div
                [ngClass]="{
                  'text-start me-2': resolution === 1,
                  'd-flex justify-content-between align-items-center': resolution === 2,
                }"
              >
                <div [class.text-start]="resolution === 2">
                  <div
                    [ngClass]="{
                      'text-size-nl': resolution === 1,
                      'text-size-sm': resolution === 2,
                    }"
                  >
                    Intereses generados
                  </div>
                  <div
                    class=""
                    [ngClass]="{
                      'text-size-lg': resolution === 1 && totalReceived <= 99999999,
                      'text-size-md': resolution === 1 && totalReceived >= 99999999,
                      'font-semibold': resolution === 1,
                      'font-bold text-black-100': resolution === 2,
                    }"
                  >
                    {{ interestGenerated | currency: 'CO' }}
                  </div>
                </div>
                <div [class.text-end]="resolution === 2">
                  <div
                    [ngClass]="{
                      'text-size-nl mt-2': resolution === 1,
                      'text-size-sm text-black-100': resolution === 2,
                    }"
                  >
                    Tasa efectiva anual
                    <i
                      *ngIf="resolution === 1"
                      class="bi bi-info-circle ms-1 cursor-pointer"
                      [ngbTooltip]="
                        'Tasa de interés anual que muestra el rendimiento total estimado en un año, incluyendo la capitalización de intereses.'
                      "
                    ></i>
                  </div>
                  <div
                    [ngClass]="{
                      'text-size-md font-semibold': resolution === 1,
                      'text-size-nl font-bold text-blue-60': resolution === 2,
                    }"
                  >
                    <i
                      *ngIf="resolution === 2"
                      class="bi bi-info-circle me-1 text-size-nl"
                      [ngbTooltip]="
                        'Tasa de interés anual que muestra el rendimiento total estimado en un año, incluyendo la capitalización de intereses.'
                      "
                    ></i>
                    {{ effectiveRate }}%
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Received -->
            <div
              class="col-md-6 px-0"
              [ngClass]="{
                'pt-2 border-blue-40': resolution === 2,
              }"
            >
              <div
                class="ms-4 text-md-start"
                [ngClass]="{
                  'ms-4': resolution === 1,
                  'd-flex justify-content-between align-items-center': resolution === 2,
                }"
              >
                <div
                  class="text-size-nl"
                  [ngClass]="{
                    'font-bold text-black-100': resolution === 2,
                  }"
                >
                  ¡Lo que recibes!
                </div>
                <span
                  class="text-decoration-none font-normal"
                  [ngClass]="{
                    'title-4 ': resolution === 1 && totalReceived <= 99999999,
                    'title-5': resolution === 1 && totalReceived >= 99999999,
                    'text-size-md font-semibold text-white p-2 bg-blue-100 rounded-3': resolution === 2,
                  }"
                >
                  {{ totalReceived | currency: 'CO' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <app-attended-by-coach (advisorSelected)="advisorSelected($event)"></app-attended-by-coach>

        <div
          class="d-flex justify-content-center align-items-center mt-3"
          [ngClass]="{
            'mx-5': resolution === 1,
            'mx-3': resolution === 2,
          }"
          [class.opacity-50]="loading"
          *ngIf="turboCDT"
        >
          <div class="form-check d-flex align-items-center gap-2">
            <input
              class="form-check-input"
              type="radio"
              name="paymentMethod"
              id="pseOption"
              [value]="'pse'"
              [disabled]="loading"
              [(ngModel)]="selectedPayment"
            />
            <label class="form-check-label cursor-pointer" for="pseOption">
              <img [src]="env.S3_STATIC_FILES + '/images/web/pse.png'" alt="PSE" class="pse-pay" />
            </label>
          </div>

          <div class="form-check d-flex align-items-center gap-2 ms-md-5 ms-4">
            <input
              class="form-check-input"
              type="radio"
              name="paymentMethod"
              id="otherOption"
              [value]="'other'"
              [disabled]="loading"
              [(ngModel)]="selectedPayment"
            />
            <label class="form-check-label font-semibold text-black-100 cursor-pointer" for="otherOption">
              Otro medio de pago
            </label>
          </div>
        </div>

        <div
          [ngClass]="{
            'mx-0': resolution === 1,
            'mx-3': resolution === 2,
          }"
        >
          <!-- Best Option Badge -->
          @if (turboCDT && selectedPayment === 'other') {
            <div class="text-center my-4">
              <div
                class="d-inline-block text-blue-180 rounded-pill py-2 px-3"
                [ngClass]="{
                  'option-turbo-badge': turboCDT && selectedPayment === 'other',
                  'text-size-sm': resolution === 2,
                }"
              >
                @if (turboCDT && selectedPayment === 'other') {
                  El modo <b>Turbo</b> es exclusivo para pagos con <b>PSE</b>
                }
              </div>
            </div>
          }

          <!-- Bonus card -->
          <div
            *ngIf="
              BonusResult &&
              BonusResult.isValid &&
              BonusResult.bonusTag != 'ruleta-mejor-tasa' &&
              ((BonusResult.roulettePrize != null && BonusResult.roulettePrize.bonusTag != 'MEJOR_TASA') ||
                BonusResult.roulettePrize == null)
            "
            class="border-0 py-3 px-md-4 px-3 bg-green-20 mt-md-0 mt-3"
            [ngClass]="{
              'rounded-0': resolution === 1,
              'rounded-4': resolution === 2,
            }"
          >
            <h6 class="fw-bold text-size-nl text-blue-180 text-center">Adicional a tu CDT</h6>
            <div class="ps-md-3 p-0">
              <div class="row m-0 justify-content-between align-items-center p-0">
                <p
                  class="m-0 text-blue-180 text-start col-md-7 col-7 m-0 lh-1 pe-md-2 p-0"
                  [ngClass]="{
                    'text-size-sm': resolution === 2,
                  }"
                >
                  MejorCDT te regala un <b>bono extra</b> en tu cuenta bancaria, que recibirás
                  <b>una vez el CDT esté activo</b>.
                </p>

                <div class="col-md-5 col-5 text-end lh-1 p-0">
                  <div
                    class="text-green fw-bold lh-1 p-0"
                    [ngClass]="{
                      'title-4': resolution === 1,
                      'title-5': resolution === 2,
                    }"
                  >
                    <span>+$</span><span>{{ BonusResult.bonusAmount | thousandSeparator }}</span>
                  </div>
                  <div class="text-green text-size-sm p-0">
                    @if (isPercentageBonus(BonusResult)) {
                      {{ getBonusDisplayValue(BonusResult) }}
                    }
                    de Cashback
                  </div>
                </div>
              </div>
              <hr />
              <div class="row m-0 justify-content-between align-items-center p-0">
                <p
                  class="m-0 text-blue-180 text-start col-md-auto col-auto m-0 fw-bold p-0"
                  [ngClass]="{
                    'text-size-md': resolution === 1,
                    'text-size-sm': resolution === 2,
                  }"
                >
                  Tu ganancia total sera:
                </p>
                <div
                  class="col-md-6 col-auto text-end lh-1 p-0"
                  [ngClass]="{
                    'title-4': resolution === 1,
                    'title-5': resolution === 2,
                  }"
                >
                  <div class="text-green fw-bold lh-1 p-0">
                    <span>$</span><span>{{ BonusResult.bonusAmount + totalReceived | thousandSeparator }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="my-3 p-md-4 p-3 bg-blue-5 rounded-5" *ngIf="dataBank.bank_id === 31">
            <div class="row">
              <div
                class="col-12 col-md-1 d-flex align-items-center justify-content-center text-blue-100 mb-2 mb-md-0"
                *ngIf="resolution === 1"
              >
                <i class="bi bi-info-circle"></i>
              </div>
              <div
                class="col-12 col-md-11 text-center text-md-start"
                [ngClass]="{
                  'text-size-nl': resolution === 1,
                  'text-size-sm': resolution === 2,
                }"
              >
                Cuando decidas retirar tu CDT, esta entidad solo permite que tu dinero llegue a una cuenta a nombre tuyo
                y no de un tercero
              </div>
            </div>
          </div>

          <!-- Confirm Button -->
          <div
            class="text-center mb-3"
            [ngClass]="{
              'mt-3': dataBank.bank_id != 31,
            }"
          >
            <div
              class="alert alert-warning alert-dismissible fade show col-md-11 col-12 text-md-start mx-auto text-size-sm"
              role="alert"
              *ngIf="interestGenerated <= 0"
            >
              El monto que ingresaste no genera intereses para el plazo seleccionado. Te recomendamos revisar el valor
              de tu inversión o elegir un plazo diferente para obtener rentabilidad.
            </div>
            <button
              class="btn btn-primary-blue py-3 px-5 rounded-pill btn-confirm ga_resultado_simulador_confirmar_{{
                dataBank.applies_turbo_cdt ? 'turbo_cdt' : utils.deleteSpace(dataBank.bank_label).toLowerCase()
              }}"
              [class.w-100]="resolution === 2"
              [class.disabled]="loading"
              [class.opacity-75]="loading"
              [disabled]="!selectedOption || loading || interestGenerated <= 0"
              (click)="onConfirmClick()"
            >
              <span class="px-5 description-3-size fw-bold">
                @if (loading) {
                  <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                } @else {
                  Confirmar
                }
              </span>
            </button>
          </div>

          <!-- Help Link -->
          <div class="text-center mb-4">
            ¿Necesitas ayuda? Escríbenos
            @if (env.BRAND === 'coltefinanciera') {
              <a href="https://api.whatsapp.com/message/FHJFAPESCA2NG1?autoload=1&app_absent=0" target="_blank">
                aquí
              </a>
            } @else {
              <a
                href="https://api.whatsapp.com/send?phone=573160234714&&text=Hola,%20estoy%20en%20la%20p%C3%A1gina%20de%20MejorCDT%20escogiendo%20los%20detalles%20de%20mi%20CDT%20y%20quisiera%20hablar%20con%20un%20Asesor"
                target="_blank"
              >
                aquí
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  `,
  styles: `
    .btn-confirm {
      transition: all 0.5s !important;
    }
    .btn-confirm:hover {
      box-shadow: 4px 11px 8px #00000026;
      transition: all 0.5s !important;
    }
    .icon-investment-card {
      top: 5px;
      left: 50px;
    }

    .img-aperture {
      height: 50px;
    }

    .border-blue-100 {
      border: 1px solid;
    }

    .border-blue-40 {
      border-top: 1px solid;
    }

    .opening-time-badge {
      border-radius: var(--bs-modal-border-radius) 0 var(--bs-modal-border-radius) 0;
    }

    .turbo-badge {
      background-color: #ff6b08;
      color: var(--color-white);
    }

    /* Best Option Badge */
    .option-badge,
    .option-preferred-badge {
      background: #c4feee;
    }

    .option-turbo-badge {
      background: #ffe1cd;
    }

    /* Dropdown Menu */
    .dropdown-menu {
      border-radius: 8px;
      border: 1px solid var(--color-blue-20);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .dropdown-item {
      cursor: pointer;
      padding: 8px 16px;
      font-size: 0.9rem;
      color: var(--color-black-100);
    }

    .dropdown-item:hover {
      background-color: var(--color-blue-10);
    }

    .dropdown-item.active {
      background-color: var(--color-blue-20);
      color: var(--color-blue-100);
      font-weight: 500;
    }

    .dropdown-item.disabled-term {
      opacity: 0.6;
      cursor: not-allowed !important;
      background-color: #f8f9fa;
      color: #6c757d !important;
    }

    .dropdown-item.disabled-term:hover {
      background-color: #f8f9fa !important;
      color: #6c757d !important;
    }

    .form-check-input[type='radio'] {
      width: 1.5em;
      height: 1.5em;
      cursor: pointer;
      border: 1px solid var(--color-black-100);
      accent-color: var(--color-blue-100, --color-blue-60);
    }
    .pse-pay {
      width: 50px;
    }

    @media (max-width: 767px) {
    }
  `,
})
export class ModalInvestmentConfirmationComponent implements OnInit, OnDestroy {
  @Input() dataBank!: BankCard;
  @Input() selectedTerms: number[] = [];
  @Input() selectedOptionIndex = 0;

  @ViewChild('amountInput') amountInputRef!: ElementRef<HTMLInputElement>;

  private destroy$ = new Subject<void>();
  public env: any = environment;
  public activateEditAmount = signal<boolean>(true);
  public form!: FormGroup;
  public amount = signal<number>(0);
  public loading: boolean = false;
  public LoadFormSend: boolean = false;
  public turboCDT: boolean = false;
  public selectedPayment: string = 'other';
  public resolution: number = 0;
  public isTermDropdownOpen: boolean = false;
  public advisorSelectBranding: string = '';

  // Propiedades para sistema de bonos
  public hasActiveBonus: boolean = false;
  public BonusResult: BonusResult | null = null;
  public blockedTerms: number[] = [];
  private bonusSubscription?: Subscription;

  // Parámetros de query permitidos
  private readonly ALLOWED_QUERY_PARAMS = ['rtir', 'bono', 'valor_cdt_regalo'];

  constructor(
    public utils: UtilsMethods_Services,
    public activeModal: NgbActiveModal,
    public sessionstorage: SessionStorageUtil,
    public bonusService: BonusService,
    private globals: Globals,
    private fb: FormBuilder,
    private cookieUtil: CookieUtil,
    private _gta_events: GtmService,
    private _api_get_simulate_investment: SimulateInvestmentV2Service,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private _screenService: ScreenService,
    private bonusProcessHelper: BonusProcessHelper,
  ) {
    this.isMobileSubscribe();
  }

  /**
   * @description Inicializa el componente, carga el monto desde la cookie y configura el formulario.
   * También selecciona el índice del término mayor y valida si aplica TurboCDT.
   */
  ngOnInit(): void {
    const cookieAmount = this.cookieUtil.get('amount');
    if (cookieAmount && !isNaN(Number(cookieAmount))) {
      this.amount.set(Number(cookieAmount));
    } else {
      this.amount.set(10000000);
    }
    this.addFormControl();

    // Seleccionar el índice del term mayor si hay terms
    this.selectedOptionIndex = this.getIndexOfMaxSelectedTerm();

    if (this.dataBank.applies_turbo_cdt) {
      this.getValidateTurboCDT();
    }

    // Inicializar sistema de bonos
    this.subscribeToBonusService();
  }

  /**
   * @description Limpia las suscripciones al destruir el componente.
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.bonusSubscription) {
      this.bonusSubscription.unsubscribe();
    }
  }

  /**
   * @description Agrega el control 'amount' al formulario con validaciones.
   * El valor inicial se formatea para mostrar separadores de miles.
   */
  addFormControl(): void {
    const amountSeparated = this.utils.thousandsSeparator(this.amount());
    this.form = this.fb.group({
      amount: [amountSeparated, [Validators.required, Validators.min(50000)]],
    });
  }

  advisorSelected(event: string): void {
    this.advisorSelectBranding = event;
  }

  /**
   * @description Retorna la opción de banco seleccionada actualmente.
   */
  get selectedOption(): BankOption | null {
    if (!this.dataBank || !this.dataBank.options || this.dataBank.options.length === 0) {
      return null;
    }
    return this.dataBank.options[this.selectedOptionIndex] || this.dataBank.options[0];
  }

  /**
   * @description Retorna el plazo de la inversión de la opción seleccionada.
   */
  get investmentTerm(): number {
    return this.selectedOption ? this.selectedOption.term : 0;
  }

  /**
   * @description Calcula los intereses generados para la opción seleccionada.
   */
  get interestGenerated(): number {
    const interestGenerated = this.selectedOption ? this.selectedOption.roi - this.amount() : 0;

    if (interestGenerated <= 0) {
      return 0;
    }

    return interestGenerated;
  }

  /**
   * @description Retorna la tasa efectiva anual de la opción seleccionada.
   */
  get effectiveRate(): number {
    return this.selectedOption ? this.selectedOption.rate : 0;
  }

  /**
   * @description Retorna el nombre del banco de la opción seleccionada.
   */
  get bankName(): string {
    return this.dataBank?.bank_label || '';
  }

  /**
   * @description Retorna el total a recibir de la opción seleccionada.
   */
  get totalReceived(): number {
    return this.selectedOption ? this.selectedOption.roi : 0;
  }

  /**
   * @description Retorna las opciones válidas del banco filtradas por tasa de interés positiva.
   * Incluye una excepción para el término de 1080 días en entidades específicas como CREDIFAMILIA,
   * permitiendo que este término sea válido solo si la tasa es mayor a 0 y el banco está autorizado.
   * También permite el término de 1080 días cuando está presente en selectedTerms, sin restricción de entidad.
   * @returns Array de opciones bancarias válidas o array vacío si no existen opciones
   */
  get validOptions(): BankOption[] {
    let enablePeriod1080DaysEntity = [this.globals.ID_CREDIFAMILIA];
    return (
      this.dataBank?.options?.filter(
        (option) =>
          option.rate > 0 &&
          (option.term !== 1080 ||
            this.selectedTerms.includes(1080) ||
            enablePeriod1080DaysEntity.includes(this.dataBank.bank_id)),
      ) || []
    );
  }

  /**
   * @description Obtiene el índice original de una opción en el array dataBank.options
   * @param option - La opción de la cual obtener el índice original
   * @returns Índice en el array original
   */
  getOriginalOptionIndex(option: BankOption): number {
    return this.dataBank?.options?.findIndex((opt) => opt.term === option.term) ?? -1;
  }

  /**
   * @description Retorna el índice de la opción con la mejor tasa (rate más alta).
   * @returns Índice de la opción con mejor tasa o -1 si no existe.
   */
  get bestRateOptionIndex(): number {
    if (!this.dataBank?.options?.length) return -1;

    const maxRate = Math.max(...this.dataBank.options.map((option) => option.rate));
    return this.dataBank.options.findIndex((option) => option.rate === maxRate);
  }

  /**
   * @description Suscribe al BonusService para detectar bonos activos
   */
  private subscribeToBonusService(): void {
    this.bonusSubscription = this.bonusService.getCurrentBonus().subscribe((bonusResult: BonusResult | null) => {
      this.handleBonusResult(bonusResult);
    });
  }

  /**
   * @description Maneja el resultado del bono y actualiza el estado del componente
   * @param bonusResult - Resultado del bono desde el BonusService
   */
  private handleBonusResult(bonusResult: BonusResult | null): void {
    if (bonusResult && bonusResult.isValid) {
      // Bono detectado
      this.BonusResult = bonusResult;
      this.hasActiveBonus = true;
      // Para bonos de ruleta, no hay términos bloqueados por defecto
      if (bonusResult.bonusTag === 'ruleta') {
        this.blockedTerms = [];
      } else if (bonusResult.minTermDays) {
        this.blockedTerms = Array.isArray(bonusResult.minTermDays)
          ? bonusResult.minTermDays
          : [bonusResult.minTermDays];
      }
    } else {
      // No hay bono activo
      this.BonusResult = null;
      this.hasActiveBonus = false;
      this.blockedTerms = [];
    }
  }

  /**
   * @description Re-evalúa el bono con un nuevo monto
   * @param newAmount - Nuevo monto para evaluar el bono
   */
  private reevaluateBonusWithAmount(newAmount: number): void {
    // Reevaluar el bono si hay una configuración activa (el usuario llegó con query params de bono)
    if (this.bonusService.hasActiveBonus()) {
      this.bonusService.evaluateBonusForAmount(newAmount);
    }
  }

  /**
   * @description Alterna el estado del dropdown de términos
   */
  toggleTermDropdown(): void {
    this.isTermDropdownOpen = !this.isTermDropdownOpen;
  }

  /**
   * @description Cierra el dropdown de términos
   */
  closeTermDropdown(): void {
    this.isTermDropdownOpen = false;
  }

  CloseModalCheckParameters() {
    const cookieAmount = this.cookieUtil.get('amount');
    this.reevaluateBonusWithAmount(Number(cookieAmount));
    this.activeModal.dismiss();
  }

  /**
   * @description Verifica si un término debe estar deshabilitado por bono activo
   * @param term Término en días
   * @returns true si el término debe estar deshabilitado
   */
  isTermDisabled(term: number): boolean {
    return this.bonusService.isTermVisuallyBlocked(term);
  }

  /**
   * @description Obtiene el mensaje del tooltip para un término deshabilitado
   * @param term - El término en días
   * @returns Mensaje dinámico para el tooltip
   */
  public getDisabledTermTooltip(term: number): string {
    return this.bonusService.getTermTooltipMessage(term);
  }

  /**
   * @description Cambia el índice de la opción seleccionada cuando el usuario selecciona otro plazo.
   * Previene la selección de términos deshabilitados por CDT Regalo.
   * @param optionIndex - Índice de la nueva opción seleccionada.
   */
  public onTermSelectionChange(optionIndex: number): void {
    const selectedOption = this.dataBank?.options?.[optionIndex];
    if (selectedOption && !this.isTermDisabled(selectedOption.term)) {
      // Manejar automáticamente activación/desactivación del bono según el término
      this.bonusService.handleTermSelection(selectedOption.term);

      this.selectedOptionIndex = optionIndex;
      this.closeTermDropdown();

      // Recalcular el bono con el monto y plazo seleccionados
      if (this.bonusService.hasActiveBonus()) {
        const amount = this.amount();
        const term = selectedOption.term;
        this.bonusService.evaluateBonusForAmount(amount, term);
      }
    }
  }

  /**
   * @description Filtra los parámetros de query para mantener solo los permitidos.
   * @param params - Todos los parámetros de query recibidos.
   * @returns Objeto con solo los parámetros permitidos.
   */
  private filterAllowedQueryParams(params: any): { [key: string]: any } {
    const filteredParams: { [key: string]: any } = {};

    this.ALLOWED_QUERY_PARAMS.forEach((paramName) => {
      if (params[paramName] !== undefined && params[paramName] !== null) {
        filteredParams[paramName] = params[paramName];
      }
    });

    return filteredParams;
  }

  /**
   * @description Maneja la confirmación de la inversión. Si el usuario está logueado, navega a la siguiente ruta;
   * si no, abre el modal de login. Separa la lógica en métodos auxiliares.
   */
  public onConfirmClick(): void {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
      const allowedParams = this.filterAllowedQueryParams(params);
      const processData = this.buildProcessData(allowedParams);
      this.GtmTagCheckParameters();
      if (this.isUserLoggedIn()) {
        this.handleLoggedInUser(processData, allowedParams);
      } else {
        this.handleGuestUser(processData, allowedParams);
      }
    });
  }

  GtmTagCheckParameters() {
    this._gta_events.triggerGTMEvent('ga_astro_btn_confirmar_general', 'ModalInvestmentConfirmationComponent');
    this._gta_events.triggerGTMEvent(
      `ga_astro_btn_confirmar_${this.dataBank.bank_id}`,
      'ModalInvestmentConfirmationComponent',
    );

    if ([24, 29].includes(this.dataBank.bank_id)) {
      if (this.cookieUtil.check('device_simulation_token')) {
        this._gta_events.triggerGTMEvent(
          'ga_js_btn_check_parameters_returning',
          'ModalInvestmentConfirmationComponent',
        );
      } else {
        this._gta_events.triggerGTMEvent('ga_js_btn_check_parameters_none', 'ModalInvestmentConfirmationComponent');
      }
    }
  }

  /**
   * @description Construye el objeto con los datos del proceso a partir del estado actual.
   * @param allowedParams - Parámetros de query permitidos filtrados.
   */
  private buildProcessData(allowedParams: { [key: string]: any }): any {
    let extra: any = {};

    // Si el usuario seleccionó un asesor, agregar branding al extra
    if (this.advisorSelectBranding != '') {
      extra.flamingo_advisor = this.advisorSelectBranding;
    }

    return {
      bank_id: this.dataBank.bank_id,
      bank_name: this.dataBank.bank_label,
      bank_amount: this.amount(),
      phone: this.cookieUtil.get('phone-full'),
      extra: extra, 
      bank_term: (this.selectedOption?.term ?? 0) / 30,
      bank_rate: this.selectedOption?.rate || 0,
      turbo: this.turboCDT && this.selectedPayment === 'pse',
      allowedParams: allowedParams,
      environment_simulate: 'astro',
    };
  }

  /**
   * @description Determina si el usuario está logueado.
   * @returns true si el usuario tiene token de sesión, false en caso contrario.
   */
  private isUserLoggedIn(): boolean {
    return this.cookieUtil.check('id_token_user') === true;
  }

  /**
   * @description Maneja la lógica cuando el usuario está logueado: cierra el modal y navega a la ruta de procesos.
   * @param processData - Datos del proceso a enviar en el estado de navegación.
   * @param allowedParams - Parámetros de query permitidos para la redirección.
   */
  private handleLoggedInUser(processData: any, allowedParams: { [key: string]: any }): void {
    this._gta_events.triggerGTMEvent('ga_astro_btn_otp_general', 'ModalInvestmentConfirmationComponent');
    this._gta_events.triggerGTMEvent(
      `ga_astro_btn_otp_${this.dataBank.bank_id}`,
      'ModalInvestmentConfirmationComponent',
    );
    // Elimina allowedParams del objeto de estado, solo va en queryParams
    const { allowedParams: _allowedParams, ...newProcessData } = processData;
    this.LoadFormSend = true;
    this.bonusProcessHelper.handleBonusProcess(newProcessData, 'closeModalCheckParameters');
  }

  /**
   * @description Maneja la lógica cuando el usuario NO está logueado: abre el modal de login y cierra el modal actual.
   * @param processData - Datos del proceso a enviar al modal de login.
   * @param allowedParams - Parámetros de query permitidos para la redirección.
   */
  private handleGuestUser(processData: any, allowedParams: { [key: string]: any }): void {
    this.openLoginModal({
      data: {
        step: 2,
        disable_modal_close_button: false,
      },
      obj_info_obj_create_process: processData,
      modal: 'btn-close-confirm-parameters',
      allowedParams: allowedParams, // Pasar los parámetros permitidos al modal de login
    });
    this.activeModal.dismiss();
  }

  /**
   * @description Abre el modal de login y pasa los datos necesarios al componente hijo.
   * @param data - Datos a enviar al modal de login.
   */
  private openLoginModal(data: any) {
    const modalRefLogin = this.modalService.open(ModalSharedLoginComponent, {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      windowClass: 'modal-dialog-fullscreen-mobile',
    });
    modalRefLogin.componentInstance.LoginDataModal = data;
  }

  /**
   * @description Permite editar el monto de la inversión. Al confirmar, actualiza el monto y simula nuevamente si cambió.
   */
  public onEditClick(): void {
    this.activateEditAmount.set(!this.activateEditAmount());
    if (this.activateEditAmount()) {
      // Al entrar en modo edición, cargar el monto actual en el input
      this.form.controls['amount'].setValue(this.utils.thousandsSeparator(this.amount()));
      setTimeout(() => {
        if (this.amountInputRef) {
          this.amountInputRef.nativeElement.focus();
        }
      });
    } else {
      // Al salir de edición, guardar el monto editado en la cookie y actualizar la variable
      let rawValue = this.form.controls['amount'].value;
      // Quitar puntos de miles para obtener el número
      let cleanValue = Number(String(rawValue).replace(/\./g, ''));
      if (!isNaN(cleanValue) && cleanValue > 0) {
        if (cleanValue !== this.amount()) {
          this.reevaluateBonusWithAmount(cleanValue);
          this.getSimulateInvestment(cleanValue);
          this.reevaluateBonusWithAmount(cleanValue);
        }
      }
    }
  }

  /**
   * @description Realiza la simulación de inversión con el nuevo monto y actualiza el estado del componente.
   * @param newAmount - Nuevo monto a simular.
   */
  private getSimulateInvestment(newAmount: number): void {
    this.loading = true;
    const amountValue = newAmount !== undefined ? newAmount : this.amount();
    const amount = amountValue.toString();
    const terms = (this.dataBank?.options || []).map((opt) => opt.term);
    const include_only = this.dataBank?.bank_id ? [this.dataBank.bank_id] : [];
    const phone = this.cookieUtil.get('phone-full');
    const body = {
      amount: amount,
      terms: terms,
      include_only: include_only,
      phone: phone,
    };

    this._api_get_simulate_investment.SIMULATE_INVESTMENT_V2(body, true).subscribe({
      next: async (response: HttpResponse<any>) => {
        if (response.body?.count > 0) {
          this.dataBank = response.body?.results[0];
          this.getValidateTurboCDT();
          this.amount.set(newAmount);
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error en la simulación:', error);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  /**
   * @description Retorna el índice en dataBank.options del term mayor presente en selectedTerms.
   * @returns Índice del término mayor o 0 si no existe.
   */
  getIndexOfMaxSelectedTerm(): number {
    if (!this.selectedTerms || !this.selectedTerms.length || !this.dataBank?.options?.length) return 0;
    const maxTerm = Math.max(...this.selectedTerms);
    const idx = this.dataBank.options.findIndex((opt) => opt.term === maxTerm);
    return idx !== -1 ? idx : 0;
  }

  /**
   * @description Formatea el valor del campo 'amount' para agregar separadores de miles.
   * Reemplaza los caracteres no numéricos y aplica el formato adecuado.
   * @param event - El evento del teclado que contiene el valor del campo.
   */
  thousandSeparator(event: any) {
    if (event.which >= 37 && event.which <= 40) return;
    let inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value;

    inputValue = inputValue.replace(/\D/g, '');
    let formattedValue = inputValue.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    inputElement.value = formattedValue;
    this.form.controls['amount'].setValue(formattedValue);
  }

  /**
   * @description Valida si la opción de TurboCDT aplica para el banco actual y actualiza el estado.
   */
  private getValidateTurboCDT(): void {
    this.turboCDT = this.dataBank.applies_turbo_cdt;
    this.selectedPayment = this.turboCDT ? 'pse' : 'other';
  }

  /**
   * @description Suscribe al servicio de pantalla para detectar si es móvil.
   * Actualiza la variable `resolution` según el estado del servicio.
   */
  public isMobileSubscribe() {
    this._screenService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((screen) => {
      this.resolution = screen;
    });
  }

  // private getValidateTurboCDT(): void {
  //   this.loading = true;
  //   const payload = {
  //     bank_id: this.dataBank?.bank_id,
  //     phone: this.cookieUtil.get('phone-full'),
  //     amount: this.amount(),
  //     term: this.investmentTerm,
  //     rate: this.effectiveRate
  //   };
  //   this._api_validate_turbo_cdt.VALIDATE_TURBO_CDT(payload)
  //     .then((data: any) => {
  //       this.handleTurboCDTResponse(data);
  //     })
  //     .finally(() => {
  //       this.loading = false;
  //     });
  // }

  // private handleTurboCDTResponse(data: any): void {
  //   switch (data.status) {
  //     case 200:
  //       this.turboCDT = true;
  //       break;
  //     case 202:
  //       this.turboCDT = false;
  //       const messageError = this.getTurboCDTErrorMessage(data.body.internal_code, data.body.message);
  //       this.showTurboCDTErrorAlert(messageError);
  //       break;
  //     default:
  //       this.turboCDT = false;
  //       break;
  //   }
  // }

  // private getTurboCDTErrorMessage(internalCode: string, defaultMessage: string): string {
  //   const errorMessages: { [key: string]: string } = {
  //     "T001": "has abierto un proceso con este banco, por lo que tu información personal y financiera ya está registrada",
  //     "T002": "el monto supera 25 SMMLV",
  //     "T003": "has abierto procesos con MejorCDT entre todos juntos superan los 25 SMMLV",
  //     "T004": "el monto supera 25 SMMLV"
  //   };
  //   return errorMessages[internalCode] || defaultMessage;
  // }

  // private showTurboCDTErrorAlert(messageError: string): void {
  //   this.openAlertConfirmation({
  //     title: `
  //       <div class="d-block text-center">
  //         <i class="mi mi-md mi-bell"></i>
  //         <div class="d-block text-blue-100">
  //           ¡Lo sentimos!
  //         </div>
  //       </div>
  //     `,
  //     message: `
  //       En esta ocasión,
  //       <span class="font-bold">
  //         no cumples con los requisitos para continuar con el proceso simplificado porque
  //         ${messageError}.
  //       </span>
  //       Sin embargo, no te preocupes, puedes seguir adelante con la apertura a través de nuestro proceso general, el cual es sencillo y totalmente seguro.
  //       <div class="d-block text-center my-2">
  //         <a href="https://api.whatsapp.com/send?phone=573160234714&text=Hola%2C%20estoy%20a%20punto%20de%20abrir%20un%20proceso%2C%20pero%20no%20est%C3%A1%20activo%20el%20Turbo%20CDT" target="_blank" class="text-black-50">
  //           Hablar con un asesor
  //         </a>
  //       </div>
  //     `,
  //     no_padding_header: false,
  //     textButtons: {
  //       confirm: {
  //         text: "Lo entiendo",
  //         id: 'select_accept_denial_referred_code'
  //       }
  //     }
  //   });
  // }

  // openAlertConfirmation(modalData: { title: string, message: string, textButtons: {}, no_padding_header: boolean }): void {
  //   const modalRef = this.modalService.open(AlertConfirmComponent,
  //     {
  //       centered: true,
  //       windowClass: 'modal-confirmation-process-warning-turbocdt'
  //     }
  //   );
  //   modalRef.componentInstance.modalData = modalData;
  //   modalRef.componentInstance.getResult().subscribe((result: boolean) => {
  //     if (result) {
  //       modalRef.close();
  //     }
  //   });
  // }

  /**
   * MÉTODOS DE DISPLAY - Delegación al BonusService centralizado para el template
   */

  /**
   * Verifica si el bono es de tipo porcentual usando el BonusService
   * @param bonusResult Resultado del bono a evaluar
   * @returns true si es porcentual
   */
  isPercentageBonus(bonusResult: BonusResult | null): boolean {
    return BonusService.isPercentageBonus(bonusResult);
  }

  /**
   * Obtiene el valor del bono formateado según el tipo usando el BonusService
   * @param bonusResult Resultado del bono
   * @returns string con el valor formateado
   */
  getBonusDisplayValue(bonusResult: BonusResult | null): string {
    const currentConfig = this.bonusService.getActiveBonusConfigValue();
    return BonusService.getBonusDisplayValue(bonusResult, currentConfig);
  }

  /**
   * Obtiene la etiqueta apropiada para el tipo de bono usando el BonusService
   * @param bonusResult Resultado del bono
   * @returns string con la etiqueta (Bono, Cashback)
   */
  getBonusLabel(bonusResult: BonusResult | null): string {
    return BonusService.getBonusLabel(bonusResult);
  }
}
